<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-b-6 m-r-6'">

    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">Documentos</div>
        <mat-menu #docmenu="matMenu">
            <button mat-menu-item (click)="OnEmployeeDocumentClick()">Documento del Trabajador</button>
            <mat-divider></mat-divider>
            <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos605"
                [routerLink]="['/informe-medico',this.actuationService.CurrentLeaveId,actuationOperation.InformeMedico]">Informe
                Medico</button>
            <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos601"
                [routerLink]="['/documento-medico',this.actuationService.CurrentLeaveId,actuationOperation.DocumentoNoMedico]">Documento
                no médico</button>
            <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos601"
            [routerLink]="['/documento-sms',this.actuationService.CurrentLeaveId,actuationOperation.SmsEntregado]">SMS entregado</button>
            <button mat-menu-item *ngIf="sharedService.Permissions.HasPermisos601"
            [routerLink]="['/documento-sms',this.actuationService.CurrentLeaveId,actuationOperation.SmsNoEntregado]">SMS no entregado</button>

        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="docmenu">
            <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
        </button>
    </div>
    <div class="card-actuation p-l-10 pb-8 header-Atributos outer-border"
        *ngIf="documentService.IsEmployeeDocumentsVisible">
        <h5 class="m-6 font-bold">Documentos del Trabajador</h5>
        <div class="p-r-10">
            <div>
                <table class="table table-striped w100">
                    <caption></caption>
                    <tr>
                        <th></th>
                    </tr>
                    <thead>
                        <div *ngFor="let doc  of documentService.employeeDocuments">
                            <tr>
                                <td class="w-5-txt-a-center"><span class="{{doc.Icon}}"></span></td>
                                <td class="date-w">{{doc.Date | date :'dd/MM/yyy'}}</td>
                                <td matTooltip="{{doc.TipoActuacion}}">{{doc.Title}}</td>
                                <td class="w-5-txt-a-center w-3">
                                    <span [matMenuTriggerFor]="employeeDocumentOptions"
                                        *ngIf="ShowEmployeeOptionButton">
                                        <mat-icon
                                            class="mat-icon material-icons mat-icon-no-color f-s-15 color-blueviolet doc-option"
                                            role="img" aria-hidden="true">
                                            more_vert
                                        </mat-icon>
                                    </span>
                                    <mat-menu #employeeDocumentOptions="matMenu" id="{{doc.DocumentoId}}">
                                        <button mat-menu-item *ngIf="doc.DocumentType!=='DOC'"
                                            (click)="ViewDocument(doc)">Ver</button>
                                        <a mat-menu-item [href]="GetHref(doc)|safeHtml"
                                            [download]="GetDocName(doc)">Descargar</a>
                                        <button mat-menu-item (click)="confirmDialog(doc)">Eliminar</button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </div>
                    </thead>
                </table>
            </div>
            <div class="m-auto" *ngIf="documentService.isLoading">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
        </div>
    </div>
    <div class="card-actuation p-l-10  pb-8 header-Atributos outer-border"
        *ngIf="documentService.IsActiveLeaveDocumentsVisible||documentService.IsOtherLeaveDocumentsVisible">
        <div *ngIf="documentService.IsActiveLeaveDocumentsVisible">
            <h5 class="m-6 font-bold">Documentos de la Baja Activa</h5>
            <div class="p-r-10">
                <div>
                    <table class="table table-striped w100">
                        <caption></caption>
                        <tr>
                            <th></th>
                        </tr>
                        <thead>
                            <div
                                *ngFor="let documetData  of documentService.activeLeaveDocuments ">
                                <tr>
                                    <td class="w-5-txt-a-center"><span class={{documetData.IconSrc}}></span></td>
                                    <td class="date-w">{{documetData.Fecha | date :'dd/MM/yyy'}}</td>
                                    <td matTooltip="{{documetData.TipoActuacion}}">{{documetData.Description}}</td>
                                    <td class="w-5-txt-a-center w-3 ">
                                        <span [matMenuTriggerFor]="activeLeaveDocumentOptions">
                                            <mat-icon
                                                class="mat-icon material-icons mat-icon-no-color f-s-19 color-blueviolet doc-option"
                                                role="img" aria-hidden="true">
                                                more_vert
                                            </mat-icon>
                                        </span>
                                        <mat-menu #activeLeaveDocumentOptions="matMenu">
                                            <a target="_blank" mat-menu-item
                                                *ngIf="( documetData.GrabacionId !== null) || ( documetData.DocumentoId !== null)"
                                                (click)="ViewLeaveDocument(documetData)">Ver</a>
                                            <a mat-menu-item
                                                *ngIf="documetData.GrabacionId !== null || documetData.DocumentoId !== null"
                                                [href]="GetLeaveDocumentHref(documetData)|safeHtml"
                                                [download]="GetLeaveDocName(documetData)">Descargar</a>
                                            <button mat-menu-item
                                                *ngIf="sharedService.Permissions.HasPermisos521"
                                                (click)="deleteDocumentById(documetData.DocumentoId)">Eliminar</button>
                                        </mat-menu>
                                    </td>
                                </tr>
                                <tr>
                            </div>
                        </thead>
                    </table>
                </div>
                <div class="m-auto" *ngIf="documentService.isLoading">
                    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </div>
            </div>
        </div>
        <div *ngIf="documentService.IsOtherLeaveDocumentsVisible">
            <h5 class="m-6 font-bold">Documentos de Bajas Anteriores</h5>
            <div class="p-r-10">
                <div>
                    <table class="table table-striped w100">
                        <caption></caption>
                        <tr>
                            <th></th>
                        </tr>
                        <thead>
                            <div *ngFor="let documetData  of documentService.otherLeaveDocuments">
                                <tr>
                                    <td class="w-5-txt-a-center"><span class={{documetData.IconSrc}}></span></td>
                                    <td class="date-w">{{documetData.Fecha | date :'dd/MM/yyy'}}</td>
                                    <td matTooltip="{{documetData.TipoActuacion}}">{{documetData.Description}}</td>
                                    <td class="w-5-txt-a-center  w-3">
                                        <span [matMenuTriggerFor]="otherLeaveDocumentOptions">
                                            <mat-icon
                                                class="mat-icon material-icons mat-icon-no-color f-s-15 color-blueviolet doc-option"
                                                role="img" aria-hidden="true">
                                                more_vert
                                            </mat-icon>
                                        </span>
                                        <mat-menu #otherLeaveDocumentOptions="matMenu">
                                            <a target="_blank" mat-menu-item
                                                *ngIf="( documetData.GrabacionId !== null) || ( documetData.DocumentoId !== null)"
                                                (click)="ViewLeaveDocument(documetData)">Ver</a>
                                            <a mat-menu-item
                                                *ngIf="documetData.GrabacionId !== null || documetData.DocumentoId !== null"
                                                [href]="GetLeaveDocumentHref(documetData)|safeHtml"
                                                [download]="GetLeaveDocName(documetData)">Descargar</a>
                                            <button mat-menu-item
                                                *ngIf="documetData.GrabacionId !== null && sharedService.Permissions.HasPermisos521"
                                                (click)="deleteDocumentById(documetData.DocumentoId)">Eliminar</button>
                                        </mat-menu>
                                    </td>
                                </tr>
                                <tr>
                            </div>
                        </thead>
                    </table>
                </div>
                <div class="m-auto" *ngIf="documentService.isLoading">
                    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </div>
            </div>
        </div>

    </div>
</div>